import { Record as record } from 'immutable';

import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve, resolveAll } from '../../../../helpers/LinkMapper';

import Transaction from './Transaction';

const fieldSchema = {
    "date": [resolve.with(trainTime)],
    "editable": [resolve.with(Boolean)],
    "transactions": [resolveAll.as(Transaction)],
    "editableUntil": [resolve.with(trainTime)]
};

class DailyTransaction extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(DailyTransaction, json, getResolvers(fieldSchema));
    }

    isEditable () {
        return this.editable;
    }
}

export default DailyTransaction;
